import React from 'react';
import { createRoot } from 'react-dom/client';
import Tooltip, { TooltipConstants } from '@Components/Tooltip/index';
import '@Components/Tooltip/GlobalTooltips.custom.scss';

function GlobalTooltips() {
  return <Tooltip id={TooltipConstants.ids.GlobalHover} place="top" html />;
}

// eslint-disable-next-line react/no-render-return-value
const renderGlobalTooltips = (container) => {
  const root = createRoot(container);
  root.render(<GlobalTooltips />);
  return root;
};

export const init = () => {
  const root = document.createElement('section');
  root.setAttribute('class', 'global-tooltips-root');
  document.body.appendChild(root);

  renderGlobalTooltips(root);
};

export default GlobalTooltips;
